import React from 'react';
import { Dispatch } from 'redux';
import { PowerBIEmbed } from "powerbi-client-react";
import * as PowerBi from 'powerbi-client';
import { Spinner } from 'react-bootstrap';
import * as DashboardStore from '../../store/Dashboard';
import { User } from 'oidc-client';
import { ExportFileType } from '../../types/Common/Enums/ExportFileType';


type DashboardViewProps = {
    dispatch: Dispatch;
    dashboardId: string;
    dashboardState: DashboardStore.DashboardState;
    user: User;
    actions:  typeof DashboardStore.actionCreators;
}

interface DashboardViewState {
    dashboard: PowerBi.Dashboard | undefined;
    reportContainerHeight: number;
    reportContainerHeightPx: string;
}


class DashboardView extends React.Component<DashboardViewProps, DashboardViewState> {
    public constructor(props: DashboardViewProps) {
        super(props);
        this.state = {
            dashboard: undefined,
            reportContainerHeight: 0,
            reportContainerHeightPx: "100%",
        };
        this.powerBiEmbedFullScreen = this.powerBiEmbedFullScreen.bind(this);
        this.getEmbeddedComponent = this.getEmbeddedComponent.bind(this);
    }

    public componentDidMount() {
        window.addEventListener("resize", this.updateReportContainer.bind(this));
        this.props.actions.unloadDashboardEmbeddedViewDetails();
        this.ensureDataFetched();

        this.updateReportContainer();
    }

    public componentDidUpdate() {
        if (!this.props.dashboardState.isLoadedEmbeddedViewDetails) {
            this.ensureDataFetched();
        }
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.updateReportContainer.bind(this));
    }

    private ensureDataFetched(){
        this.props.actions.requestDashboardEmbeddedViewDetails(this.props.dashboardId);
    }

    private updateReportContainer() {
        var reportContainerElement = document.getElementById('dashboardContainer');
        if (reportContainerElement == null) {
            return;
        }
            
        var reportContainerTop = reportContainerElement.getBoundingClientRect().top;

        var footerElement = document.getElementsByTagName('footer');
        if (footerElement == null || footerElement.length < 1) {
            return;
        }

        var footerRect = footerElement[0].getBoundingClientRect();

        let height = footerRect.top - 20 - reportContainerTop;

        // Give React a break, screen resize can change 1 pixel at a time
        if (this.state.reportContainerHeight !== height 
            && Math.abs(this.state.reportContainerHeight - height) > 15) {
                console.log("Setting report container height to: "+height+"px");
                this.setState({reportContainerHeight: height, reportContainerHeightPx: height+"px"});
        }
    }

    public exportFileRequest(exportFileType: ExportFileType) {

    }

    powerBiEmbedFullScreen() {
        if (this.state.dashboard) {
            this.state.dashboard.fullscreen();
        }
    }

    getEmbeddedComponent = (embeddedDashboard: PowerBi.Embed) => {
        let embedDashboard1 = embeddedDashboard as PowerBi.Dashboard;
        this.setState({dashboard: embedDashboard1});

        // Fix the UI 
        this.updateReportContainer();
    }

    render() {
        const pbiModels = PowerBi.models;
        let embeddedRecordAccess = this.props.dashboardState.embeddedDashboardDetailsData.find(x => x.aliasName === this.props.dashboardId || x.recordId == this.props.dashboardId);

        const NoDataComponent: React.FunctionComponent = (): React.ReactElement => {
            if (!this.props.dashboardState.isLoadedEmbeddedViewDetails && embeddedRecordAccess === undefined){
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">No Power Bi Dashboard found. (or something is broken!)</p>
                    </div>
                );
            }
            else{
                return (
                    <div className="d-flex justify-content-center mt-3">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                );
            }
        };

    

        if(embeddedRecordAccess === undefined){
            return (
                <div>Dashboard Not Found</div>
            );
        }

        return (
            <div id='dashboardContainer' style={{height: `${this.state.reportContainerHeightPx}` }}>
                <PowerBIEmbed
                    embedConfig={{
                        type: embeddedRecordAccess?.type,
                        embedUrl: embeddedRecordAccess?.embedUrl,
                        accessToken: embeddedRecordAccess?.accessToken,
                        id: embeddedRecordAccess?.recordId,
                        settings: {
                            layoutType: pbiModels.LayoutType.Custom,
                            customLayout: {
                              displayOption: pbiModels.DisplayOption.FitToPage,
                            },
                        },
                    }}
                    cssClassName={"powerbi-embedded-report-style"}
                    getEmbeddedComponent={this.getEmbeddedComponent}
                />
           </div>
        );
    }

};

export default DashboardView;